import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignmentLeftBar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"alignment-left-bar"} maskId="square-filled-radius-0-stroke-1-IconAlignmentLeftBar"><path fillRule="evenodd" clipRule="evenodd" d="M3 4V20H2V4H3ZM7 6H22V7H7V6ZM7 11.5H22V12.5H7V11.5ZM7 17H16V18H7V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlignmentLeftBar;
